import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import heading from 'css/heading';

const styles = {
  ...heading
};

class Header extends React.Component {
  render = () => {
    const { classes, children, heading } = this.props;
    return (
      <div>
        <div className={classes.headerContainer}>
          <Typography className={classes.headerTitle} variant='title'>
            {heading}
          </Typography>
          <div className={classes.headerButton}>
            {children}
          </div>
        </div>
        <Divider />
      </div>
    );
  };
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js